import { Icon, IconProps } from '@elkaso-app/web-design';
import { HiAnnotation } from 'react-icons/hi';

export const PocInternalFeedbackIcon = (props: IconProps) => {
  return <Icon as={HiAnnotation} width='24px' height='24px' viewBox='0 0 24 24' fill='#757575' {...props} />;
};
